import SingleMetric from './SingleMetric';

export default SingleMetric;
